import React, { useContext, useEffect, useState } from 'react';
import { TeApiContext } from '@ecommerce/nest-ssr/common';
import { CONTAINER_CLASS, CONTAINER_CLASS_ACTIVE } from '../product-tabs-content';
import Link from 'atomic/utilization/link';

import './product-tabs-navi.scss';

interface ProductTabsNaviProps {
    keys: string[];
    labels: string[];
    defaultValue: string;
}

const ProductTabsNavi: React.FC<ProductTabsNaviProps> = ({ keys, labels, defaultValue }) => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    const [active, setActive] = useState(defaultValue);

    const change = (key: string): void => {
        const oldItem = document.querySelector(`.${CONTAINER_CLASS_ACTIVE}`);
        const newItem = document.querySelector(`.${CONTAINER_CLASS}[data-key="${key}"]`);

        if (oldItem) {
            oldItem.classList.remove(CONTAINER_CLASS_ACTIVE);
        }

        if (newItem) {
            newItem.classList.add(CONTAINER_CLASS_ACTIVE);
        }

        const boxBestOffersDiv = document.getElementById('box-best-offers');

        if (boxBestOffersDiv) {
            setTimeout(() => {
                boxBestOffersDiv.classList[key === 'ceny' ? 'add' : 'remove']('hidden');
            }, 0);
        }

        setActive(key);
    };

    const hashchange = (): void => {
        const hash = window.location.hash.substr(1);

        if (keys.indexOf(hash) >= 0) {
            change(hash);
        }
    };

    useEffect(() => {
        hashchange();

        window.addEventListener('hashchange', hashchange, { passive: true });

        return (): void => window.removeEventListener('hashchange', hashchange);
    }, []);

    return (
        <div className={`product-tabs__navi ${api.getDevice()}`}>
            {
                keys.map((key, idx) => (
                    <Link
                        key={key}
                        href={`#${key}`}
                        onClick={(): void => change(key)}
                        className={`product-tabs__navi-item ${key === active && 'product-tabs__navi-item--active'} ${api.getDevice()}`}
                    >
                        {labels[idx]}
                    </Link>
                ))
            }
        </div>
    );
};

export default ProductTabsNavi;
